<template>
  <div class="page-card">
    <el-card>
      <div slot="header">系统管理 - 操作日志</div>
      <el-table :data="list" border stripe size="small">
        <el-table-column prop="id" label="ID" width="70" />
        <el-table-column prop="adminUsername" label="管理员" width="140" />
        <el-table-column prop="method" label="方法" width="80" />
        <el-table-column prop="path" label="路径" />
        <el-table-column prop="ip" label="IP" width="140" />
        <el-table-column prop="createdAt" label="时间" width="180" />
      </el-table>

      <div style="text-align:right;margin-top:16px;">
        <el-pagination
          layout="prev, pager, next, total"
          :total="total"
          :page-size="query.pageSize"
          :current-page.sync="query.page"
          @current-change="handlePageChange"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import request from '@/api/request'

export default {
  name: 'OperationLogList',
  data() {
    return {
      query: {
        page: 1,
        pageSize: 20
      },
      list: [],
      total: 0
    }
  },
  created() {
    this.fetchList()
  },
  methods: {
    fetchList() {
      request
        .get('/logs', { params: this.query })
        .then(res => {
          const data = res.data || res
          this.list = (data && data.items) || []
          this.total = (data && data.total) || 0
        })
    },
    handlePageChange(page) {
      this.query.page = page
      this.fetchList()
    }
  }
}
</script>

